export const HTMLClasses = {
  chartComponent: "chart-component",
  chartConfig: "chart-config",
} as const;
